export const propertyId = "high-grove";